import { BrowserModule } from '@angular/platform-browser';
import { NgModule, provideNgReflectAttributes } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from 'components/shared/modules';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { environment } from 'src/environments/environment';
import { getBaseHref } from 'src/app/core/utilities/runtime.utils';
import { Configuration } from 'projects/data/src/lib/configuration';
import { APP_BASE_HREF } from '@angular/common';
import { ImaginePayAuthModule, Configuration as ImaginePayConfiguration } from 'imagine-pay-api';
import { MsalBroadcastService, MsalGuard, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { SecurityModule } from './features/security/security.module';
import { AppComponent } from './app.component';
import {
  LOCATIONS_DIALOG_COMPONENT,
  PROVIDERS_DIALOG_COMPONENT,
  SPLIT_VISIT_DIALOG_COMPONENT,
  VISIT_RULES_DIALOG_COMPONENT
} from 'components/shared';
import { LocationsDialogComponent } from './features/files/locations/locations-dialog/locations-dialog.component';
import { ProvidersDialogComponent } from './features/files/providers/providers-dialog/providers-dialog.component';
import { SplitVisitComponent } from './features/accounts/account-details/patient-visits/split-visit/split-visit.component';
import { VisitRulesComponent } from './features/accounts/account-details/patient-visits/visit-rules/visit-rules.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule, 
    BrowserAnimationsModule,
    CoreModule,
    MaterialModule,
    SharedModule,
    MsalModule,
    ImaginePayAuthModule.forRoot(environment.imaginePayConfig)
  ],
  providers: [
    provideNgReflectAttributes(),
    {
      provide: Configuration,
      useFactory: () =>
        new Configuration({
          basePath: environment.apiConfig.baseUrl
        }),
      multi: false
    },
    {
      provide: ImaginePayConfiguration,
      useFactory: () =>
        new Configuration({
          basePath: environment.imaginePayConfig.baseUrl,
          credentials: { Bearer: 'Bearer' }
        }),
      multi: false
    },
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseHref
    },
    MsalService,
    MsalGuard, 
    MsalBroadcastService,
    SecurityModule,
    {
      provide: LOCATIONS_DIALOG_COMPONENT,
      useValue: LocationsDialogComponent
    },
    {
      provide: PROVIDERS_DIALOG_COMPONENT,
      useValue: ProvidersDialogComponent
    },
    {
      provide: SPLIT_VISIT_DIALOG_COMPONENT,
      useValue: SplitVisitComponent
    },
    {
      provide: VISIT_RULES_DIALOG_COMPONENT,
      useValue: VisitRulesComponent
    }
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {
  
}
